import * as React from "react";

import { Levels } from "../../../../Levels/Levels";
import { PressureLevels } from "../../../../../../rest/GroupAction";
import { Unit } from "../../../../../../rest/Misc";
import { ActionType } from "../flux";
import { Polyglot } from "../../../../../../polyglot";

interface Props
{
    polyglot: Polyglot;
    levels: PressureLevels;
    unit: Unit;
    axleCount: number;
    setAxle: (axle: number) => void;
    setBaseline: (value: number) => void;
    setDefineAlertLevels: (flag: boolean) => void;
    setRedMax: (value: number) => void;
    setYellowMax: (value: number) => void;
    setYellowMin: (value: number) => void;
    setRedMin: (value: number) => void;
}

export class PressureGroupAction extends React.Component<Props, any>
{
    static defaultProps = {
        type: ActionType.SetPressure
    };
    
    render()
    {
        const { polyglot, unit, levels, setBaseline, setRedMax, setYellowMax, setYellowMin, setRedMin } = this.props;
        const { Axle, RelLevelMaximumRed, RelLevelMaximumYellow, RelLevelMinimumYellow, RelLevelMinimumRed } = levels;
        
        return (
            <Levels isBaselineVisible
                polyglot={polyglot}
                unitName={unit ? unit.Name : ''}
                axleCount={this.props.axleCount} axle={Axle} setAxle={this.props.setAxle}
                baseline={levels.Baseline} setBaseline={setBaseline}
                defineAlertLevels={this.props.levels.DefineAlertLevels} setDefineAlertLevels={this.props.setDefineAlertLevels}
                redMax={RelLevelMaximumRed} setRedMax={setRedMax}
                yellowMax={RelLevelMaximumYellow} setYellowMax={setYellowMax}
                yellowMin={RelLevelMinimumYellow} setYellowMin={setYellowMin}
                redMin={RelLevelMinimumRed} setRedMin={setRedMin}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Vehicle/BatchEdit/GroupActions/PressureGroupAction.tsx